
import React from "react";
import styled from "styled-components";

export const CropperWrapper = styled.div`
    position: relative;
    flex: 1;
    display: flex !important;
    background: #00000029;
    padding: 40px;

    @media (max-width: 768px) {
        height: 100px;
        margin: 2rem 2rem;
    }
`;

export const VideoControlsRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    gap: 10px;
    width: 100%; 
    max-width: 100%; 
    flex-wrap: nowrap;

    @media (max-width: 480px) {
        flex-wrap: wrap; 
        justify-content: space-between;
    }
`;

export const VideoControlBox = styled.div`
    z-index: 99999;
    position: absolute;
    top: 90%;
    width: 100%;
    max-width: 686px;
    height: 62px;
    background: #FFFFFF;
    box-shadow: 0px 3px 6px #00000029;
    border: 1px solid #D8DEEC;
    border-radius: 10px;
    opacity: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin: 34px auto 0 auto;
    position: relative;
    padding: 0 8px;
`;

export const ProgressBarWrapper = styled.div`
    width: 572px;
    height: 4px;
    background: #EBEBEB;
    border-radius: 100px;
    opacity: 1;
    margin: 0 auto 8px auto;
    position: relative;
    margin-bottom: 20px;
`;

export const ProgressBar = styled.div`
    width: ${({ percent }) => percent}%;
    height: 4px;
    background-color: #D8DEEC;
    transition: width 0.1s linear;
`;

export const TimeDisplay = styled.div`
    pointer-events: none;
    width: 580x;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 16px;
    color: #4B5155;
    margin: 4px auto;
`;

export const PlayPauseButton = styled.button`
    background: none;
    border: none;
    outline: none;
    cursor: pointer;
    display: flex;
    align-items: center;
`;

export const IconButton = styled.button`
    background: none;
    border: none;
    cursor: pointer;
    padding: 4px;
    display: flex;
    align-items: center;
    justify-content: center;

    &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }

    svg {
        width: 24px;
        height: 24px;
    }
`;

export const TrimBox = styled.div`
    position: absolute;
    z-index: 99;
    left: ${({ left }) => `${left}%`};
    width: ${({ width }) => `${width}%`};
    top: -6px;
    height: 12px;
    background: rgba(130, 145, 178, 0.2);
    border: 2px solid #8291b2;
    border-top: none;
    cursor: pointer;
    display: ${({ visible }) => (visible ? "block" : "none")};
`;

export const TimeLabel = styled.span`
    position: absolute;
    background: #D8DEEC;
    color: #fff;
    font-size: 12px;
    padding: 2px 6px;
    border-radius: 6px;
    border: 1px solid #8291b2;
`;

export const Handle = styled.div`
    position: absolute;
    top: -40px;
    width: 14px;
    height: 50px;
    background: transparent;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: ew-resize;

    &::before {
        content: '';
        width: 2px;
        height: 100%;
        background: #D8DEEC;
    }
`;

export const VideoCropPreviewBox = styled.div`
    position: absolute;
    top: -60px;
    left: ${({ left }) => `${left}%`};
    width: ${({ width }) => `${width}%`};
    height: 50px;
    background: black;
    border: 2px solid #D8DEEC;
    border-radius: 8px;
    overflow: hidden;
    display: flex;
    align-items: stretch;
    justify-content: flex-start;
    z-index: 10;
    box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.2);

    img {
        flex-shrink: 0;
        height: 100%;
    }
`;

export const TrimCancelButton = styled.button`
    position: absolute;
    bottom: -30px;
    top: -70px;
    width: 26px;
    height: 24px;
    right: -12px;
    background: #D8DEEC;
    border: 1px solid #D8DEEC;
    border-radius: 100px;
    padding: 4px 6px;
    z-index: 1000;
    cursor: pointer;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

    display: flex;
    align-items: center;
    justify-content: center;

    img {
        display: block;
        pointer-events: none;
    }
`;

export const PlayIcon = () => (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
        <circle cx="16" cy="16" r="16" fill="#D8DEEC" />
        <polygon points="13,10 24,16 13,22" fill="#fff" />
    </svg>
);

export const PauseIcon = () => (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
        <circle cx="16" cy="16" r="16" fill="#D8DEEC" />
        <rect x="12" y="10" width="3" height="12" fill="#fff" />
        <rect x="17" y="10" width="3" height="12" fill="#fff" />
    </svg>
);

export const SaveIcon = () => (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
        <circle cx="16" cy="16" r="16" fill="#D8DEEC" />
        <path
            d="M11 17L14.5 20.5L21 14"
            stroke="white"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);